var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_9972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.333 9.16658H11.333V4.16659C11.333 3.94557 11.2452 3.73361 11.0889 3.57733C10.9326 3.42105 10.7207 3.33325 10.4997 3.33325C10.2787 3.33325 10.0667 3.42105 9.91042 3.57733C9.75414 3.73361 9.66634 3.94557 9.66634 4.16659V9.16658H4.66634C4.44533 9.16658 4.23337 9.25438 4.07709 9.41066C3.92081 9.56694 3.83301 9.7789 3.83301 9.99992C3.83301 10.2209 3.92081 10.4329 4.07709 10.5892C4.23337 10.7455 4.44533 10.8333 4.66634 10.8333H9.66634V15.8333C9.66634 16.0543 9.75414 16.2662 9.91042 16.4225C10.0667 16.5788 10.2787 16.6666 10.4997 16.6666C10.7207 16.6666 10.9326 16.5788 11.0889 16.4225C11.2452 16.2662 11.333 16.0543 11.333 15.8333V10.8333H16.333C16.554 10.8333 16.766 10.7455 16.9223 10.5892C17.0785 10.4329 17.1663 10.2209 17.1663 9.99992C17.1663 9.7789 17.0785 9.56694 16.9223 9.41066C16.766 9.25438 16.554 9.16658 16.333 9.16658Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_9972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2df22d3c468b41b42fdcbe2b7b34cbfd.svg";
export { ForwardRef as ReactComponent };